export default __webpack_public_path__ + "static/media/mkc_logo.9fee8be7.svg";